module.exports = __webpack_public_path__ + "static/media/Vincent Crabbe 2.92dd1764.jpg";